import axios from './axios'

export const fetch_job = async (jobId) => {
  var config = {
    method: 'get',
    url: `${window._env_.REACT_APP_API_URL}/${window._env_.REACT_APP_API_VERSION}/workplace/jobs/${jobId}`,
    headers: { 
      'Content-Type': 'application/json'
    }
  };
  try {
    var result = await axios(config)
    return result.data
  }
  catch(error) {
    return {success: false, message: error}
  }
}

export const fetch_job_applications_count = async (jobId) => {
  var config = {
    method: 'get',
    url: `${window._env_.REACT_APP_API_URL}/${window._env_.REACT_APP_API_VERSION}/workplace/jobs/${jobId}/applicationsCount`,
    headers: { 
      'Content-Type': 'application/json'
    }
  };
  try {
    var result = await axios(config)
    return result.data
  }
  catch(error) {
    return {success: false, message: error}
  }
}

export const fetch_job_statistics = async (jobId) => {
  var config = {
    method: 'get',
    url: `${window._env_.REACT_APP_API_URL}/${window._env_.REACT_APP_API_VERSION}/workplace/jobs/${jobId}/statistics`,
    headers: { 
      'Content-Type': 'application/json'
    }
  };
  try {
    var result = await axios(config)
    return result.data
  }
  catch(error) {
    return {success: false, message: error}
  }
}

export const fetch_job_application_statistics = async (jobId) => {
  var config = {
    method: 'get',
    url: `${window._env_.REACT_APP_API_URL}/${window._env_.REACT_APP_API_VERSION}/workplace/jobs/${jobId}/applications/statistics`,
    headers: { 
      'Content-Type': 'application/json'
    }
  };
  try {
    var result = await axios(config)
    return result.data
  }
  catch(error) {
    return {success: false, message: error}
  }
}

export const fetch_jobs = async (filter, orderBy, limit, skip) => {
  var url = `${window._env_.REACT_APP_API_URL}/${window._env_.REACT_APP_API_VERSION}/workplace/jobs?`
  if(filter){
    for (const key in filter) {
      if(key === 'visibility' || key === 'organizerId')
        url += `&${key}=${filter[key]}`
      else
        url += `&filter=AND(${key}:${filter[key]})`
    }
  }

  if(skip)
    url += `&skip=${skip}`
  if(limit)
    url += `&limit=${limit}`
  if(orderBy)
    url += `&orderBy=${orderBy}`
    
  var config = {
    method: 'get',
    url: url,
    headers: { 
      'Content-Type': 'application/json'
    }
  };
  try {
    var result = await axios(config)
    return result.data
  }
  catch(error) {
    return {success: false, message: error}
  }
}

export const fetch_config_applications_state = async () => {
  var url = `${window._env_.REACT_APP_API_URL}/${window._env_.REACT_APP_API_VERSION}/workplace/applications/status`
    
  var config = {
    method: 'get',
    url: url,
    headers: { 
      'Content-Type': 'application/json'
    }
  };
  try {
    var result = await axios(config)
    return result.data
  }
  catch(error) {
    return {success: false, message: error}
  }
}

export const fetch_applications = async (filter, orderBy, limit, skip) => {
  var url = `${window._env_.REACT_APP_API_URL}/${window._env_.REACT_APP_API_VERSION}/workplace/applications?`

  if(filter){
    for (const key in filter) {
      url += `&${key}=${filter[key]}`
    }
  }

  if(skip)
    url += `&skip=${skip}`
  if(limit)
    url += `&limit=${limit}`
  if(orderBy)
    url += `&orderBy=${orderBy}`
    
  var config = {
    method: 'get',
    url: url,
    headers: { 
      'Content-Type': 'application/json'
    }
  };
  try {
    var result = await axios(config)
    return result.data
  }
  catch(error) {
    return {success: false, message: error}
  }
}

export const insert_jobSkill = async (jobId, name) => {
  try{
    var data = JSON.stringify({name:name});

    var config = {
      method: 'post',
      url: `${window._env_.REACT_APP_API_URL}/${window._env_.REACT_APP_API_VERSION}/workplace/jobs/${jobId}/skills`,
      headers: { 
        'Content-Type': 'application/json'
      },
      data : data
    };
    var result = await axios(config)
    return result.data
  }
  catch(error) {
    return {success: false, message: error}
  }
}

export const delete_jobSkill = async (jobId, id) => {
  try{
    var config = {
      method: 'delete',
      url: `${window._env_.REACT_APP_API_URL}/${window._env_.REACT_APP_API_VERSION}/workplace/jobs/${jobId}/skills/${id}`,
      headers: { 
        'Content-Type': 'application/json'
      }
    };
    var result = await axios(config)
    return result.data
  }
  catch(error) {
    return {success: false, message: error}
  }
}

export const insert_jobAktivitie = async (jobId, name) => {
  try{
    var data = JSON.stringify({name:name});

    var config = {
      method: 'post',
      url: `${window._env_.REACT_APP_API_URL}/${window._env_.REACT_APP_API_VERSION}/workplace/jobs/${jobId}/activities`,
      headers: { 
        'Content-Type': 'application/json'
      },
      data : data
    };
    var result = await axios(config)
    return result.data
  }
  catch(error) {
    return {success: false, message: error}
  }
}

export const delete_jobActivitie = async (jobId, id) => {
  try{
    var config = {
      method: 'delete',
      url: `${window._env_.REACT_APP_API_URL}/${window._env_.REACT_APP_API_VERSION}/workplace/jobs/${jobId}/activities/${id}`,
      headers: { 
        'Content-Type': 'application/json'
      }
    };
    var result = await axios(config)
    return result.data
  }
  catch(error) {
    return {success: false, message: error}
  }
}

export const insert_jobInterview = async (jobId, interview) => {
  try{
    var data = JSON.stringify(interview);

    var config = {
      method: 'post',
      url: `${window._env_.REACT_APP_API_URL}/${window._env_.REACT_APP_API_VERSION}/workplace/jobs/${jobId}/interview`,
      headers: { 
        'Content-Type': 'application/json'
      },
      data : data
    };
    var result = await axios(config)
    return result.data
  }
  catch(error) {
    return {success: false, message: error}
  }
}

export const delete_jobInterview = async (jobId, id) => {
  try{
    var config = {
      method: 'delete',
      url: `${window._env_.REACT_APP_API_URL}/${window._env_.REACT_APP_API_VERSION}/workplace/jobs/${jobId}/interview/${id}`,
      headers: { 
        'Content-Type': 'application/json'
      }
    };
    var result = await axios(config)
    return result.data
  }
  catch(error) {
    return {success: false, message: error}
  }
}

export const update_job = async (jobId, data) => {
  try{
    var data = JSON.stringify(data);

    var config = {
      method: 'patch',
      url: `${window._env_.REACT_APP_API_URL}/${window._env_.REACT_APP_API_VERSION}/workplace/jobs/${jobId}`,
      headers: { 
        'Content-Type': 'application/json'
      },
      data : data
    };
    var result = await axios(config)
    return result.data
  }
  catch(error) {
    return {success: false, message: error}
  }
}

export const insert_job = async (data) => {
  try{
    var data = JSON.stringify(data);

    var config = {
      method: 'post',
      url: `${window._env_.REACT_APP_API_URL}/${window._env_.REACT_APP_API_VERSION}/workplace/jobs`,
      headers: { 
        'Content-Type': 'application/json'
      },
      data : data
    };
    var result = await axios(config)
    return result.data
  }
  catch(error) {
    return {success: false, message: error}
  }
}

export const fetch_active_jobs = async () => {
  var url = `${window._env_.REACT_APP_API_URL}/${window._env_.REACT_APP_API_VERSION}/workplace/jobs/active`

  var config = {
    method: 'get',
    url: url,
    headers: { 
      'Content-Type': 'application/json'
    }
  };
  try {
    var result = await axios(config)
    return result.data
  }
  catch(error) {
    return {success: false, message: error}
  }
}

export const insert_application = async (jobId, application) => {
  try{
    var data = JSON.stringify(application);
    var config = {
      method: 'post',
      url: `${window._env_.REACT_APP_API_URL}/${window._env_.REACT_APP_API_VERSION}/workplace/jobs/${jobId}/applications`,
      headers: { 
        'Content-Type': 'application/json'
      },
      data: data
    };
    var result = await axios(config)
    return result.data
  }
  catch(error) {
    return {success: false, message: error}
  }
}